/*
 * @Author: HWD
 * @Date: 2021-10-28 13:57:26
 * @LastEditors: HWD
 * @LastEditTime: 2021-12-27 10:49:23
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
 */
// const TFetch = {
//     /* * get请求 * url:请求地址 * params:参数 * callback:回调函数 * */
//     static get(url,params,callback){
//         if (params) {
//             let paramsArray = [];
//             //拼接参数
//             Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
//             if (url.search(/\?/) === -1) {
//                 url += '?' + paramsArray.join('&')
//             } else {
//                 url += '&' + paramsArray.join('&')
//             }
//         }
//         //fetch请求
//         fetch(url,{
//             method: 'GET',})
//             .then((response) => {
//                 callback(response)
//             })
//             .catch((error) => {
//                 alert(error)
//             });
//     },
//     /*
//      *  post请求
//      *  url:请求地址
//      *  params:参数,这里的参数格式是：{param1: 'value1',param2: 'value2'}
//      *  callback:回调函数
//      * */
//     static postJSON(url,params,callback){
//         //fetch请求
//         fetch(url,{
//             method: 'POST',
//             headers: {
//               'Accept': 'application/json',
//               body:JSON.stringify(params)
//             }   
//         })
//             .then((response) => response.json()) .then((responseJSON) => { callback(responseJSON) }) .catch((error) => { console.log("error = " + error) }); 
//     },
//     /*
//      *  post请求
//      *  url:请求地址
//      *  params:参数,这里的参数要用这种格式：'key1=value1&key2=value2'
//      *  callback:回调函数
//      * */

    


// }
const baseUrl = 'https://hkkj.net.cn/movecarapi/'
// const baseUrl = 'http://localhost/movecarapi/'
const Fetch = async (url = '', data = {}, method = 'GET')=>{
    let requestConfig = {}
    method = method.toUpperCase();
    url = baseUrl + url;
    console.log(url,data,method)
    let dataStr = ''; //数据拼接字符串
    // switch(method){
    //     case 'GET':      
    //         Object.keys(data).forEach(key => {
    //             dataStr += key + '=' + data[key] + '&';
    //         })
            
    //         if (dataStr !== '') {
    //             dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
    //             url = url + '?' + dataStr;
    //             console.log(url)
    //         }
    //         break;
    //     case 'POST':
    //         break;
    // }
    if(method == 'GET'){
        Object.keys(data).forEach(key => {
            dataStr += key + '=' + data[key] + '&';
        })
        
        if (dataStr !== '') {
            dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
            url = url + '?' + dataStr;
            //console.log(url)
        }

    }


    if (method == 'POST') {
        requestConfig = {
            //credentials: 'include',
            method: method,
            headers: {
                //'Accept': 'application/json',// 用户代理可处理的媒体类型// 用户代理可处理的媒体类型
                'Content-Type': 'application/json',// 报文主体对象类型       
                // 'Access-Control-Allow-Origin':'*',
                // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
                // 'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
            },
            //mode: "cors",// 跨域
            //cache: "force-cache",
            body: JSON.stringify(data)      
        }

    }
    
    try {
        const response = await fetch(url, requestConfig);
        const responseJson = await response.json();
        return responseJson
    } catch (error) {
        throw new Error(error)
    }
    
    
}
export default Fetch;
// export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
//     type = type.toUpperCase();
//     url = baseUrl + url;
//     console.log(type,url,data,method)
//     if (type == 'GET') {
//         let dataStr = ''; //数据拼接字符串
//         Object.keys(data).forEach(key => {
//             dataStr += key + '=' + data[key] + '&';
//         })

//         if (dataStr !== '') {
//             dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
//             url = url + '?' + dataStr;
//         }
//     }

//     if (window.fetch && method == 'fetch') {
//         let requestConfig = {
//             credentials: 'include',
//             method: type,
//             headers: {
//                 'Accept': 'application/json',// 用户代理可处理的媒体类型// 用户代理可处理的媒体类型
//                 'Content-Type': 'application/json'// 报文主体对象类型
//             },
//             mode: "cors",// 跨域
//             cache: "force-cache"
//         }

//         if (type == 'POST') {
//             Object.defineProperty(requestConfig, 'body', {
//                 value: JSON.stringify(data)
//             })
//         }

//         try {
//             const response = await fetch(url, requestConfig);
//             const responseJson = await response.json();
//             return responseJson
//         } catch (error) {
//             throw new Error(error)
//         }
//     } else {
//     // 若是浏览器不支持 fetch
//         return new Promise((resolve, reject) => {
//             let requestObj;
//             if (window.XMLHttpRequest) {
//                 requestObj = new XMLHttpRequest();
//             } else {
//                 return//requestObj = new ActiveXObject;
//             }

//             let sendData = '';
//             if (type == 'POST') {
//                 sendData = JSON.stringify(data);
//             }

//             requestObj.open(type, url, true);
//             requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
//             requestObj.send(sendData);

//             requestObj.onreadystatechange = () => {
//                 if (requestObj.readyState == 4) {
//                     if (requestObj.status == 200) {
//                         let obj = requestObj.response
//                         if (typeof obj !== 'object') {
//                             obj = JSON.parse(obj);
//                         }
//                         resolve(obj)
//                     } else {
//                         reject(requestObj)
//                     }
//                 }
//             }
//         })
//     }
// }